import store from "../Redux/Store";

export function getStoreType() {
  const storeData = store.getState().storeReducer.store;
  return storeData?.services?.store_type_flag;
}
